var _rect, _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGabinete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 36,
    height: 54,
    stroke: "#A80A01",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5H48M24 30H48M48.75 21V16.5C48.75 14.8431 47.4069 13.5 45.75 13.5H26.25C24.5931 13.5 23.25 14.8431 23.25 16.5V21H48.75Z",
    stroke: "#A80A01",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8093 51.5159L38.2476 52.0129L38.8093 51.5159C38.1233 50.7406 37.1185 50.25 36 50.25C34.8815 50.25 33.8767 50.7406 33.1907 51.5159C32.6059 52.1769 32.25 53.0478 32.25 54C32.25 56.0711 33.9289 57.75 36 57.75C38.0711 57.75 39.75 56.0711 39.75 54C39.75 53.0478 39.3941 52.1769 38.8093 51.5159Z",
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51V54",
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.25,
    cy: 17.25,
    r: 1.5,
    fill: "#A80A01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGabinete);
export default __webpack_public_path__ + "static/media/Gabinete.f1d72bb7025e4e5a7ce9fa7e20900dbc.svg";
export { ForwardRef as ReactComponent };